// extracted by mini-css-extract-plugin
module.exports = {"Container":"menu-select-body_Container__cbI0W"};